import { render } from "./SmsSetup.vue?vue&type=template&id=78465018&scoped=true"
import script from "./SmsSetup.vue?vue&type=script&lang=js"
export * from "./SmsSetup.vue?vue&type=script&lang=js"

import "./SmsSetup.vue?vue&type=style&index=0&id=78465018&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78465018"]])

export default __exports__